{
  "login": "Log in",
  "logout": "Log out",
  "email": "Email",
  "emailAddress": "Email Address",
  "emailPlaceholder": "name@company.com",
  "password": "Password",
  "forgotPassword": "Forgot password?",
  "rememberMe": "Remember me",
  "signIn": "Sign in",
  "signUp": "Sign up",
  "user": "User",
  "tagline": "Rental Workflow Platform",
  "welcomeBackSubtitle": "Welcome back. Please enter your details.",
  "createAccountSubtitle": "Create an account to start managing your properties.",
  "showPassword": "Show password",
  "hidePassword": "Hide password",
  "quickAccess": "Quick Access (QA)",
  "quickUsers": {
    "platform_sovereign": "Sovereign Platform Admin ({{name}})",
    "platform_admin": "Platform Admin ({{name}})",
    "admin": "Admin ({{name}})",
    "manager": "Manager ({{name}})",
    "owner": "Owner ({{name}})",
    "tenant": "Tenant ({{name}})",
    "vendor": "Vendor ({{name}})",
    "multi": "Adaptive Multi-Role ({{name}})"
  },
  "enterEmail": "Please enter an email address",
  "loginFailed": "Login failed",
  "authFailed": "Authentication failed",
  "apiError": "{{message}}",
  "guestSessionDetected": "Guest Session Active",
  "guestSessionDescription": "You have an unsaved guest draft. Signing in will automatically save and link your progress to your account.",
  "guestSessionMigrated": "Your guest draft has been saved to your account.",
  "passwordMode": "Password",
  "magicLinkMode": "Magic Link",
  "sendMagicLink": "Send Magic Link",
  "magicLinkSentTitle": "Check your email",
  "magicLinkSentDescription": "We've sent a magic login link to {{email}}. Click the link in your email to sign in.",
  "signInWithPassword": "Sign in with Password",
  "signInWithMagicLink": "Sign in with Magic Link",
  "or": "or",
  "resetPasswordTitle": "Reset your password",
  "resetPasswordDescription": "Enter your email address and we'll send you a link to reset your password.",
  "sendResetLink": "Send Reset Link",
  "checkYourEmail": "Check your email",
  "resetEmailSentNotice": "If an account exists for {{email}}, a password reset link has been dispatched.",
  "backToSignIn": "Back to sign in",
  "setNewPasswordTitle": "Create new password",
  "setNewPasswordDescription": "Your new password must be at least 8 characters and contain uppercase letters and numbers.",
  "newPassword": "New Password",
  "confirmNewPassword": "Confirm New Password",
  "saveNewPassword": "Reset Password",
  "ruleMinLength": "At least 8 characters",
  "ruleUppercase": "At least one uppercase letter",
  "ruleNumber": "At least one number",
  "ruleMatch": "Passwords match",
  "passwordResetSuccessTitle": "Password reset successfully",
  "redirectingToLogin": "Redirecting to login...",
  "invalidResetLinkTitle": "Invalid or expired link",
  "invalidResetLinkDescription": "This password reset link is invalid or has expired.",
  "requestNewResetLink": "Request a new link",
  "authenticatingLink": "Signing you in...",
  "pleaseWait": "Please wait while we verify your magic link.",
  "magicLinkErrorTitle": "Unable to sign in",
  "requestNewLink": "Request a new login link",
  "tabs": {
    "signIn": "Sign In",
    "signUp": "Create Account"
  },
  "fields": {
    "fullName": "Full Name",
    "fullNamePlaceholder": "Jane Doe",
    "confirmPassword": "Confirm Password",
    "phone": "Phone Number",
    "phonePlaceholder": "+1 555 123 4567"
  },
  "buttons": {
    "createAccount": "Create Account",
    "creatingAccount": "Creating Account..."
  },
  "errors": {
    "passwordMismatch": "Passwords do not match",
    "accountExists": "An account with this email already exists. Please sign in instead."
  },
  "accountLinkedNotice": "Account successfully linked with {{provider}}.",
  "enterFullName": "Please enter your full name (minimum 2 characters)",
  "enterValidEmail": "Please enter a valid email address",
  "passwordRequirementsNotMet": "Password does not meet the security requirements",
  "organizationName": "Organization Name",
  "organizationDefaultPlaceholder": "Defaults to your name",
  "organizationDefaultNotice": "Your primary workspace will be initialized automatically.",
  "google": "Google",
  "facebook": "Facebook",
  "instagram": "Instagram",
  "whatsapp": "WhatsApp",
  "sms": "SMS",
  "providerUnavailableTooltip": "{{provider}} sign-in is not configured yet",
  "enterPhone": "Please enter a valid phone number",
  "enterValidCode": "Please enter the 6-digit code",
  "otpSendFailed": "Failed to send OTP",
  "otpVerifyFailed": "Invalid verification code",
  "otpPhoneDescription": "We will send a 6-digit verification code to your phone.",
  "otpCodeDescription": "Enter the 6-digit code sent to {{phone}}.",
  "phoneFormatHint": "Include country code (e.g. +56 for Chile, +1 for US).",
  "sendVerificationCode": "Send Verification Code",
  "changePhoneNumber": "Change phone",
  "resendCode": "Resend code",
  "resendInCountdown": "Resend in {{count}}s",
  "cancelToSignIn": "Back to sign in",
  "useDifferentEmail": "Use a different email",
  "missingMagicToken": "Missing magic link token",
  "magicLinkVerifyFailed": "Could not verify magic link",
  "magicLinkRequestFailed": "Failed to send magic link",
  "completingSocialLogin": "Completing your sign-in...",
  "socialCallbackErrorTitle": "Social sign-in could not be completed",
  "socialCallbackDenied": "Authorization was canceled or declined.",
  "unsupportedSocialProvider": "Unsupported social authentication provider.",
  "missingSocialCode": "Missing authorization code from social login provider.",
  "invalidOAuthState": "Security state mismatch during social sign-in. Please try again.",
  "socialProviderNotConfigured": "This social login provider is not configured on this environment.",
  "dataDeletionStatusTitle": "Social Data Deletion Completed",
  "dataDeletionStatusDescription": "Your Meta (Facebook / Instagram) social login identity and associated account link have been removed from HomyOS.",
  "dataDeletionCodeLabel": "Confirmation Code",
  "social": {
    "continueWithApple": "Continue with Apple",
    "signInWithApple": "Sign in with Apple",
    "continueWithGoogle": "Continue with Google",
    "continueWithFacebook": "Continue with Facebook",
    "continueWithInstagram": "Continue with Instagram",
    "continueWithWhatsApp": "Continue with WhatsApp",
    "continueWithSms": "Sign in with SMS",
    "lastUsed": "Last Used",
    "orContinueWith": "Or continue with",
    "providerDisabled": "This sign-in method is currently unavailable.",
    "placeholderToast": "{{provider}} sign-in is coming in the next release. For mobile, use Apple Sign-In or Password."
  },
  "hero": {
    "badge": "HomyOS 2.0",
    "title": "The operating system for property workflows.",
    "subtitle": "Manage units, screen tenants, sign contracts, and collect payments all from one beautiful, unified platform.",
    "pill1": "99.8% On-Time Rent Collection",
    "pill1Sub": "Automated UF reconciliation",
    "pill2": "Automated Maintenance Dispatch",
    "pill2Sub": "HITL contractor approval",
    "pill3": "AI Lease Screening",
    "copyright": "© 2026 HomyOS",
    "privacy": "Privacy",
    "terms": "Terms"
  },
  "qa": {
    "title": "Developer Quick Access",
    "badge": "DEV QA",
    "description": "Switch between pre-seeded personas to audit permissions, views, and workflows.",
    "groups": {
      "platform": "Platform & Operations",
      "residents": "Residents & Owners",
      "contractors": "Contractors & Field",
      "special": "Adaptive & Multi-Role"
    },
    "instantLogin": "1-Click Login",
    "fillForm": "Fill Credentials",
    "close": "Close"
  },
  "passkey": {
    "passkey": "Passkey",
    "signInWithPasskey": "Sign in with a Passkey",
    "registerTitle": "Set up a Passkey",
    "registerDescription": "Log in securely using Touch ID, Face ID, or your device screen lock without typing a password.",
    "registerButton": "Add Passkey",
    "prompt": "Use Touch ID, Face ID, or Security Key",
    "notSupported": "Passkeys are not supported on this device or browser.",
    "createdSuccess": "Passkey created successfully!",
    "authSuccess": "Passkey verified successfully!",
    "failed": "Passkey authentication failed. Please try again or use password."
  },
  "mfa": {
    "challengeTitle": "Two-Factor Authentication",
    "challengeDescription": "Enter the 6-digit security code generated by your authenticator app.",
    "subtitleSms": "Enter the 6-digit verification code sent to your phone.",
    "codeLabel": "6-Digit Security Code",
    "codePlaceholder": "000000",
    "verifyButton": "Verify & Sign In",
    "verifying": "Verifying...",
    "useBackupCode": "Use a backup code instead",
    "useTotp": "Use authenticator app code instead",
    "backupCodeLabel": "Backup Code",
    "backupCodeDescription": "Enter an 8-character single-use backup recovery code.",
    "backupCodePlaceholder": "Enter backup code (e.g. ABCD-1234)",
    "invalidCode": "Invalid security code. Please check your authenticator and try again.",
    "invalidBackupCode": "Invalid or already used backup code."
  },
  "slides": {
    "property": {
      "title": "Centralized Property Management.",
      "subtitle": "Manage units, track finances, and view analytics all in one beautiful, unified platform.",
      "pill1Title": "99.8% On-Time Rent Collection",
      "pill1Sub": "Automated UF reconciliation",
      "pill2Title": "AI Property Copilot",
      "pill2Sub": "Proactive portfolio insights"
    },
    "maintenance": {
      "title": "Automated Maintenance Dispatch.",
      "subtitle": "Connect seamlessly with verified contractors like Patricio to keep your properties in top shape.",
      "pill1Title": "Automated Maintenance Dispatch",
      "pill1Sub": "HITL contractor approval",
      "pill2Title": "Smart Quoting",
      "pill2Sub": "AI-verified repair costs"
    },
    "tenant": {
      "title": "Better Tenant Experience.",
      "subtitle": "Simplified onboarding, 100% digital contracts, and frictionless rent payments for modern tenants.",
      "pill1Title": "Faster Leasing",
      "pill1Sub": "100% Digital Contracts",
      "pill2Title": "Zero-Friction Payments",
      "pill2Sub": "Auto-recurring charges"
    }
  },
  "oauth": {
    "title": "Authorize {{clientName}}",
    "subtitle": "wants to connect to your Homy workspace",
    "clientUnknown": "External Application",
    "signInTitle": "Sign in to connect to {{clientName}}",
    "signInSubtitle": "Create an account or sign in to authorize access to your Homy workspace.",
    "permissionsRequested": "Requested permissions",
    "workspaceLabel": "Select Workspace / Organization",
    "workspaceDescription": "Choose the organization this application will be permitted to access.",
    "workspacePlaceholder": "Select an organization...",
    "noWorkspaces": "No organizations available",
    "currentAccount": "Signed in as",
    "switchAccount": "Sign in with a different account",
    "starterOrgNotice": "A starter organization will be automatically provisioned for your new account.",
    "termsNotice": "By clicking Authorize, you allow {{clientName}} to access your information in accordance with their terms and privacy policy.",
    "authorizeButton": "Authorize",
    "cancelButton": "Cancel",
    "authorizing": "Authorizing...",
    "canceling": "Canceling...",
    "scopes": {
      "openid": "Verify your identity (OpenID Connect)",
      "profile": "Access your basic profile information (name, avatar)",
      "email": "View your email address",
      "offline_access": "Maintain offline access with refresh tokens",
      "homy:all": "Full access to all Homy workspace data and operations",
      "homy:mcp": "Execute AI agent tools and Model Context Protocol (MCP) actions",
      "mcp:read": "Read-only access to properties, tasks, tenants, and maintenance via MCP",
      "mcp:write": "Create and modify tasks, maintenance orders, and properties via MCP",
      "read": "Read access to your account data",
      "write": "Write access to perform actions on your behalf"
    },
    "errors": {
      "missingParams": "Invalid authorization request: missing required parameters (client_id, redirect_uri, or code_challenge).",
      "clientFetchFailed": "Unable to verify client details. You may still proceed if you trust this application.",
      "authorizeFailed": "Failed to complete authorization. Please try again.",
      "accessDenied": "Authorization request was canceled."
    }
  }
}
